import React, { useState, useEffect } from 'react'
import { Button, ResourceContextProvider, useRedirect } from 'react-admin'
import {
  List, Stack, Typography, Divider, Box, Input, Select, MenuItem, Menu, Radio, RadioGroup, FormControlLabel, FormControl, Checkbox, FormGroup,
  Table, TableContainer, TableHead, TableBody, TableRow, Paper, Pagination, CircularProgress
} from '@mui/material'
import SyncIcon from '@mui/icons-material/Sync';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import SearchIcon from '@mui/icons-material/Search';
import SettingsIcon from '@mui/icons-material/Settings';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import EditIcon from '@mui/icons-material/Edit';
import globalStyles from '../../utils/globalStyles'
import globalConfig from '../../utils/globalConfig'
import { styled } from '@mui/material/styles';
import axios from 'axios'
import legolasApi from '../../api/legolas'
import ChannelDropDown from "../common/ChannelDropDown";
import { filter } from "lodash";
import generateToken from '../../utils/generateToken'


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2b3f7a',
    color: theme.palette.common.white,
    padding: globalStyles.common.infoTablesPadding,
    borderRight: '2px solid #fff',
    whiteSpace: 'nowrap',
    borderRadius: '0px !important'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: globalStyles.common.infoTablesPadding,
    borderRadius: '0px !important'
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));



function UsersList(props) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [columnsOpen, setColumnsOpen] = React.useState(false)
  const [anchorCol, setAnchorCol] = React.useState(null)
  const [totalCount, setTotalcount] = React.useState(0)
  const [listData, setListData] = React.useState([])
  const [selectedHeaders, setSelectedHeaders] = React.useState([
    { id: 'id', label: 'ID' }, { id: 'firstname', label: 'Name' }, { id: 'email', label: 'Email' },
    // { id: 'group_id', label: 'Group' }, 
    { id: 'telephone', label: 'Phone' }, { id: 'created_at', label: 'Customer Since' }, { id: 'updated_at', label: 'Last updated' },
    { id: 'active', label: 'Status' }, { id: 'vinculum_cust_id', label: 'Vinculum Sync ' }, { id: 'vinculum_sync_action', label: 'Re-Sync' },
    { id: 'channel', label: 'Channel' }
    // { id: 'website_id', label: 'Website' }, 
  ])
  const [searchString, setSearchString] = React.useState('')
  const [currentPage, setCurrentPage] = React.useState(1)
  const [channelData, setChannelData] = React.useState([]);
  const [registerType, setRegisterType] = useState('Registered');
  const [filters, setFilters] = useState({
    channel: '',
    register_type: 'Registered',
  });
  const [loading, setLoading] = useState(false);
  const [exportFormat, setExportFormat] = useState('csv');
  const open = Boolean(anchorEl)
  const redirect = useRedirect()
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const localStorageUser = localStorage.getItem('user');
  const user = JSON.parse(localStorageUser);
  const userChannels = Array.isArray(user?.channel) ? user.channel.map(String) : [];
  const [openAlert, setOpenAlert] = React.useState(false)
  const [alertText, setAlertText] = React.useState('')
  const [processingUsers, setProcessingUsers] = useState({});
  const clickLockRef = React.useRef({});

  const getChannel = () => {
    axios.get(`${legolasApi.url}/admin/channel/list`)
      .then((res) => {
        console.log('order res: ', res.data.data);
        //setChannelData(res.data.data);
        const allChannels = res.data.data;
        const filteredChannels = allChannels.filter(ch => userChannels.includes(ch._id));
        setChannelData(filteredChannels);
      })
      .catch((error) => console.log('Error in getting orders: ', error));
  }

  // React.useEffect(() => {
  //   const interval = setInterval(() => {
  //     const query = buildQueryParams(filters, searchString);

  //     axios.get(`${legolasApi.url}/admin/users?${query}`)
  //       .then((res) => {
  //         setListData(res.data.users);
  //       })
  //       .catch(() => { });
  //   }, 10000); // every 10 sec

  //   return () => clearInterval(interval);
  // }, [filters, searchString]);

  React.useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      getChannel();

      const query = buildQueryParams(); // no filters, fallback to userChannels

      try {
        const res = await axios.get(`${legolasApi.url}/admin/users?${query}`);
        setListData(res.data.users);
        setTotalcount(res.data.count);
      } catch (err) {
        console.log('Error fetching users:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const handleColumnClick = (e) => {
    setColumnsOpen(true)
    setAnchorCol(e.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSearch = () => {
    const query = buildQueryParams(filters, searchString.trim());
    axios.get(`${legolasApi.url}/admin/users?${query}`)
      .then((res) => {
        setListData(res.data.users);
        setTotalcount(res.data.count);
      })
      .catch((err) => console.error("Search error:", err));
  };

  const handleVinculumSync = async (user) => {
    try {
      const payload = { userId: user.id, group_id: user.group_id };
      const signedToken = generateToken(payload);

      await axios.post(`${legolasApi.url}/admin/re-sync`, payload, {
        headers: { Authorization: `Bearer ${signedToken}` }
      });

      handleAlertGen("Sync started (may take ~2 mins)");

      setListData(prev =>
        prev.map(u =>
          u.id === user.id ? { ...u, sync_status: "processing" } : u
        )
      );

    } catch (err) {
      handleAlertGen("Sync failed");
    }
  };
  const handlePagination = (event, value) => {
    const page = value - 1;
    const query = buildQueryParams(filters, searchString, { offset: page });

    setLoading(true);
    axios.get(`${legolasApi.url}/admin/users?${query}`)
      .then((res) => {
        setCurrentPage(value);
        setListData(res.data.users);
        setTotalcount(res.data.count);
      })
      .catch((err) => console.error('Pagination error:', err))
      .finally(() => setLoading(false));
  };


  const handleFilter = (field, value) => {
    const updatedFilters = { ...filters, [field]: value };
    setFilters(updatedFilters);

    if (field === 'register_type') {
      setRegisterType(value);
    }
    const isAll = value === 'All' || !value;
    const extraParams = isAll ? {} : { filter: userChannels.join(',') };
    const query = buildQueryParams(updatedFilters, searchString, extraParams);
    setLoading(true);
    axios.get(`${legolasApi.url}/admin/users?${query}`)
      .then((res) => {
        setListData(res.data.users);
        setTotalcount(res.data.count);
      })
      .catch((err) => console.log('Error in filtering users: ', err))
      .finally(() => setLoading(false));
  };


  const buildQueryParams = (filtersObj = {}, searchStr = '', extraParams = {}) => {
    const queryParams = new URLSearchParams();

    if (searchStr?.trim()) {
      queryParams.append('search', searchStr.trim());
    }

    let finalChannelIds = [];

    if (filtersObj.channel) {
      finalChannelIds = Array.isArray(filtersObj.channel)
        ? filtersObj.channel
        : [filtersObj.channel];
    } else if (userChannels.length > 0) {
      finalChannelIds = userChannels;
    }

    if (finalChannelIds.length > 0) {
      queryParams.append('filter', finalChannelIds.join(','));
    }

    if (filtersObj.register_type) {
      queryParams.append('register_type', filtersObj.register_type);
    }

    Object.entries(extraParams).forEach(([key, value]) => {
      if (key !== 'filter' && value !== undefined && value !== '') {
        queryParams.set(key, value);
      }
    });

    return queryParams.toString();
  };

  const handleAddClick = () => {
    const redirectUrl = '/users/add'
    redirect(redirectUrl)
  }

  const handleEditClick = (userId) => {
    const redirectUrl = `/users/${userId}`
    redirect(redirectUrl)
  }
  const handleAlertGen = (message) => {
    setAlertText(message)
    setOpenAlert(true)
    setTimeout(() => {
      setAlertText('')
      setOpenAlert(false)
    }, 3000)
  }
  const closeAlert = () => {
    setOpenAlert(false)
  }
  function findChecked(headerId, headerArr) {
    let checked = false
    for (let i = 0; i < headerArr.length; i++) {
      const checkElem = headerArr[i]
      if (checkElem['id'] == headerId) {
        checked = true
        break
      }
    }
    return checked
  }

  const handleGridColumns = (header) => {
    selectHeader(header.id, header.label, !header.checked)
  }

  function selectHeader(headerId, headerLabel) {
    const headerObj = { "id": headerId, "label": headerLabel }

    const headerIndex = selectedHeaders.findIndex(header => header.id === headerId);

    if (headerIndex !== -1) {
      const updatedHeaders = [...selectedHeaders];
      updatedHeaders.splice(headerIndex, 1);
      setSelectedHeaders(updatedHeaders);
    } else {
      const updatedHeaders = [...selectedHeaders, headerObj];
      setSelectedHeaders(updatedHeaders);
    }

  }
  useEffect(() => {
    if (searchString.trim() === '') {
      handleSearch();
    }
  }, [searchString]);


  function resetTableHeaders() {
    setSelectedHeaders([
      { id: 'id', label: 'ID' }, { id: 'firstname', label: 'Name' }, { id: 'email', label: 'Email' },
      // { id: 'group_id', label: 'Group' }, 
      { id: 'telephone', label: 'Phone' }, { id: 'created_at', label: 'Customer Since' }, { id: 'updated_at', label: 'Last updated' },
      { id: 'active', label: 'Activity Status' }, { id: 'vinculum_cust_id', label: 'Vinculum Sync' }, { id: 'vinculum_sync_action', label: ' Re-Sync' },
      { id: 'channel', label: 'Channel' }
      // { id: 'website_id', label: 'Website' }, 
    ])
    setColumnsOpen(false)
  }

  function getModifiedDate(inpDate) {
    let modDate = new Date(inpDate)
    let retDate = ''
    const month = modDate.toLocaleDateString('default', { month: 'short' })
    const date = modDate.getDate()
    const year = modDate.getFullYear()
    const formattedTime = modDate.getHours() + ':' + modDate.getMinutes() + ':' + modDate.getSeconds()
    return retDate + month + '  ' + date + ',  ' + year + '  ' + formattedTime
  }


  const handleExport = async () => {
    setAnchorEl(null);

    try {
      const query = buildQueryParams(filters, searchString, {
        offset: 0,
        limit: 100000,
      });

      const res = await axios.get(`${legolasApi.url}/admin/users?${query}`);
      const allUsers = res.data.users || [];

      const headers = getHeaderOptions(registerType);

      const allData = allUsers.map(user => {
        const row = {};

        headers.forEach(header => {
          const id = header.id;

          switch (id) {
            case 'firstname':
              row[id] = [user.firstname, user.lastname].filter(Boolean).join(' ') || 'N/A';
              break;

            case 'active':
              row[id] = registerType === 'Guest'
                ? 'Guest'
                : (user.active === 1 ? 'Active' : 'Not Active');
              break;

            case 'group_id':
              row[id] = registerType === 'Guest'
                ? 'N/A'
                : globalConfig.customerGroups?.[user.group_id] ?? 'N/A';
              break;
            case 'vinculum_cust_id':
              row[id] = user.vinculum_cust_id === 0 || user.vinculum_cust_id == null
                ? 'False'
                : 'True';
              break;

            default:
              row[id] = user[id] ?? 'N/A';
          }
        });

        return row;
      });

      if (exportFormat === 'csv') {
        exportToCSV(selectedHeaders, allData);
      } else if (exportFormat === 'excel') {
        exportToXML(selectedHeaders, allData);
      }
    } catch (error) {
      console.error("Export failed:", error);
    }
  };


  const exportToCSV = (headers, data, fileName = 'data.csv') => {
    const csvRows = [];

    // Add header row
    const headerRow = headers.map(header => `"${header.label}"`).join(',');
    csvRows.push(headerRow);

    // Add data rows
    data.forEach(row => {
      const rowValues = headers.map(header => {
        const value = row[header.id] !== undefined ? row[header.id] : '';
        // Escape double quotes by replacing " with ""
        const escapedValue = String(value).replace(/"/g, '""');
        return `"${escapedValue}"`;
      });
      csvRows.push(rowValues.join(','));
    });

    // Create and trigger download
    const csvString = csvRows.join('\n');
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const exportToXML = (headers, data, fileName = 'data.xml') => {
    let xmlString = '<?xml version="1.0" encoding="UTF-8"?>\n<data>\n';

    data.forEach(row => {
      xmlString += '  <row>\n';
      headers.forEach(header => {
        const value = row[header.id] !== undefined ? escapeXML(row[header.id].toString()) : '';
        xmlString += `    <${header.id}>${value}</${header.id}>\n`;
      });
      xmlString += '  </row>\n';
    });

    xmlString += '</data>';

    // Create and trigger download
    const blob = new Blob([xmlString], { type: 'application/xml;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  // Helper function to escape XML special characters
  const escapeXML = (str) => {
    return str.replace(/[<>&'"]/g, function (c) {
      switch (c) {
        case '<': return '&lt;';
        case '>': return '&gt;';
        case '&': return '&amp;';
        case '\'': return '&apos;';
        case '"': return '&quot;';
        default: return c;
      }
    });
  };

  const getHeaderOptions = (registerType) => {
    if (registerType === 'Guest') {
      return allTableHeaders.filter(
        (header) => !['id', 'updated_at'].includes(header.id)
      );
    }
    return allTableHeaders;
  };


  const allTableHeaders = [
    { id: 'id', label: 'ID', checked: true }, { id: 'firstname', label: 'Name', checked: true }, { id: 'email', label: 'Email', checked: true },
    // { id: 'group_id', label: 'Group', checked: true },
    { id: 'telephone', label: 'Phone', checked: true },
    //{ id: 'zip', label: 'ZIP', checked: true },
    //{ id: 'country', label: 'Country', checked: true }, 
    //{ id: 'state', label: 'State/Province', checked: true }, 
    { id: 'created_at', label: 'Customer Since', checked: true },
    { id: 'updated_at', label: 'Last updated', checked: true },
    { id: 'active', label: 'Status', checked: true },
    { id: 'vinculum_cust_id', label: 'Vinculum Sync', checked: true },
    { id: 'vinculum_sync_action', label: 'Re-Sync', checked: true },

    // { id: 'website_id', label: 'Website', checked: true }, 
    { id: 'channel', label: 'Channel', checked: true },
    //{ id: 'created_in', label: 'Account created in', checked: true }, 
    //{ id: 'bill_addr', label: 'Billing Address', checked: true }, { id: 'ship_addr', label: 'Shipping Address' }, { id: 'dob', label: 'Date of Birth', checked: true },
    //{ id: 'taxvat', label: 'Tax VAT Number', checked: true }, { id: 'gender', label: 'Gender', checked: true }, { id: 'street_addr', label: 'Street Address', checked: true },
    //{ id: 'city', label: 'City', checked: true },
    //{ id: 'company', label: 'Company', checked: true },
    //{ id: 'acc_lock', label: 'Account Lock', checked: true }, { id: 'otp_verified', label: 'Otp Verified', checked: true }, { id: 'mobile', label: 'Mobile Number', checked: true }
  ]

  useEffect(() => {
    if (registerType === 'Guest') {
      setSelectedHeaders(allTableHeaders.filter((h) => !['id', 'updated_at'].includes(h.id)));
    } else {
      setSelectedHeaders(allTableHeaders);
    }
  }, [registerType, allTableHeaders]);

  if (selectedHeaders.length == 0) {
    return null
  } else {
    return (
      <React.Fragment>
        <ResourceContextProvider resource="users">
          <List
            actions={null}
            sx={{
              '& .MuiTablePagination-select': {
                display: 'none !important'
              }
            }}
          >
            <Box sx={globalStyles.headerWrapperBox}>
              <Box sx={{ width: '50%', display: 'flex', margin: '20px 30px' }}>
                <Typography variant='h4'>
                  Customer
                </Typography>
                <Typography variant='subtitle1' sx={globalStyles.headerCountSubtitle}>
                  {totalCount} item(s) found
                </Typography>
              </Box>
              <Box sx={{ width: '50%', alignItems: 'center', margin: '20px 30px', marginRight: '70px' }}>
                <Button variant="contained" sx={globalStyles.createButton} onClick={() => handleAddClick()}>
                  Add New Customer
                </Button>
              </Box>
            </Box>
            <Box sx={globalStyles.headerWrapperBox}>
              <Box sx={{
                width: '100%',
                display: 'flex',
                margin: '0px 30px',
                '& .MuiInput-input': {
                  width: '300px !important',
                  padding: '5px 10px !important'
                },
                '& .MuiSvgIcon-root': {
                  paddingRight: '10px'
                },
                justifyContent: 'space-between'

              }}>
                <Input
                  type='search'
                  sx={{ border: '1px solid #2b3f7a', borderRadius: '20px', marginTop: '25px', marginRight: '5%' }}
                  endAdornment={<SearchIcon sx={{ cursor: 'pointer' }} onClick={() => handleSearch()} />}
                  placeholder='Seach by keywords'
                  onChange={(e) => setSearchString(e.target.value)}
                />
                {userChannels.length > 1 && (<ChannelDropDown channelData={channelData} handleChannelFilter={handleFilter} />)}
                <Box sx={{ display: 'flex', flexDirection: 'column', marginLeft: '20px' }}>
                  <Typography sx={{ marginBottom: '2px', fontSize: '14px', color: '#808080' }}>
                    Filter by Register Type
                  </Typography>
                  <form>
                    <Select
                      value={registerType}
                      onChange={(event) => handleFilter('register_type', event.target.value)}
                      sx={{
                        width: '200px',
                        borderRadius: '0px',
                        border: '1px solid #000',
                        height: '40px',
                        backgroundColor: '#fff'
                      }}
                    >
                      <MenuItem value="Registered">Registered</MenuItem>
                      <MenuItem value="Guest">Guest</MenuItem>
                    </Select>
                  </form>
                  {loading && (
                    <Box sx={{ display: 'flex', alignItems: 'center', marginLeft: '20px', marginTop: '25px' }}>
                      <CircularProgress size={14} thickness={4} color="primary" sx={{ animationDuration: '25s' }} />
                      <Typography sx={{ fontSize: '13px', marginLeft: '10px', color: '#2b3f7a' }}>Loading...</Typography>
                    </Box>
                  )}

                </Box>
                <Box sx={{
                  width: '50vw',
                  justifyContent: 'end',
                  textAlign: 'end',
                  '& .MuiButton-sizeSmall': {
                    lineHeight: '30px !important'
                  },
                  '& .MuiDivider-root': {
                    borderRightWidth: 'thin !important',
                    borderColor: '#2b3f7a'
                  }
                }}>
                  {/* <Button sx={globalStyles.listSubheaderIcons}>
                    <FilterAltIcon /> Filters <Divider orientation="vertical" flexItem sx={{ padding: '0px 10px' }} />
                  </Button> */}
                  <Button sx={globalStyles.listSubheaderIcons} onClick={handleColumnClick}>
                    <SettingsIcon /> Columns <ArrowDropDownIcon sx={{ '& .MuiSvgIcon-root': { paddingRight: '0px !important' } }} /> <Divider orientation="vertical" flexItem sx={{ '& .MuiDivider-root': { borderRightWidth: 'normal' } }} />
                  </Button>
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorCol}
                    open={columnsOpen}
                    onClose={() => setColumnsOpen(false)}
                    MenuListProps={{
                      'aria-labelledby': 'basic-button',
                    }}
                  >
                    <FormControl>
                      <Box sx={{ margin: '10px 20px' }}>
                        <Typography>
                          {/* {selectedHeaders.length} out of {allTableHeaders.length} visible */}
                        </Typography>
                      </Box>
                      <Box sx={{ width: '100%', borderTop: '1px solid #2b3f7a', borderBottom: '1px solid #2b3f7a', margin: '10px 20px', width: '92.5%' }}>
                        <FormGroup sx={{ display: 'grid', width: '100%', gridTemplateColumns: 'auto auto auto' }}>
                          {getHeaderOptions(registerType).map((header) => (
                            <FormControlLabel
                              key={header.id}
                              control={
                                <Checkbox
                                  checked={selectedHeaders.some((selectedHeader) => selectedHeader.id === header.id)}
                                  onChange={(e) => selectHeader(header.id, header.label)}
                                />
                              }
                              label={header.label}
                            />
                          ))}
                        </FormGroup>


                        {/* <FormGroup sx={{ display: 'grid', width: '100%', gridTemplateColumns: 'auto auto auto' }}>
                      {selectedHeaders.map((header) => {
                        if (header.id == 'id') {
                          return (
                            <FormControlLabel control={<Checkbox/>} label={header.label}/>
                          )
                        } else {
                          return (
                            <FormControlLabel control={
                            <Checkbox 
                              checked={findChecked(header.id, selectedHeaders)}
                              //checked={header.checked}
                              />}

                              label={header.label}
                              onChange={(e) => selectHeader(header.id, header.label)}
                              //onChange={(e) => handleGridColumns(header)}

                            />
                          )
                        }
                      })}
                  </FormGroup> */}
                      </Box>
                      <Box sx={{
                        display: 'flex', margin: '10px 20px', justifyContent: 'space-between !important',
                        '& .MuiButton-root': {
                          textTransform: 'capitalize',
                          color: globalStyles.colors.backgroundPrimary
                        }
                      }}
                      >
                        <Button onClick={() => resetTableHeaders()}>Reset</Button>
                        <Button onClick={() => setColumnsOpen(false)}>Cancel</Button>
                      </Box>
                    </FormControl>
                  </Menu>
                  <Button sx={globalStyles.listSubheaderIcons} onClick={handleClick}>
                    <FileUploadIcon /> Export <ArrowDropDownIcon sx={{ '& .MuiSvgIcon-root': { paddingRight: '0px !important' } }} />
                  </Button>
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      'aria-labelledby': 'basic-button',
                    }}
                    sx={{ padding: 2, borderRadius: 1, boxShadow: 3 }}

                  >
                    <FormControl component="fieldset" sx={{ padding: 2 }}>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="export-options"
                        value={exportFormat}
                        onChange={(e) => setExportFormat(e.target.value)}
                      >
                        <FormControlLabel value="csv" control={<Radio size='small' />} label="CSV" sx={{ marginBottom: 1 }} />
                        <FormControlLabel value="excel" control={<Radio size='small' />} label="Excel XML" sx={{ marginBottom: 1 }} />
                      </RadioGroup>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 2 }}>
                        <Button onClick={handleClose} sx={{ textTransform: 'none', color: 'error.main' }}>Cancel</Button>
                        <Button onClick={handleExport} variant="contained"
                          sx={{ textTransform: 'none', backgroundColor: 'primary.main', color: 'white' }}>Export</Button>
                      </Box>
                    </FormControl>
                  </Menu>
                </Box>
              </Box>
            </Box>
            {/* <CommonDataGrid rowClick="create" sx={globalStyles.datagridList}>
          {selectedHeaders.map((header) => {
            return (
              <TextField source={header.id} label={header.label}/>
            )
          })}
          <EditButton basePath='/users' label=""/>
        </CommonDataGrid> */}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', mx: '30px', mt: 1 }}>
              <Typography variant="body2" sx={{ fontWeight: 500, color: '#d35400' }}>
                Note: Clicking “Re-sync” may take up to 2 minutes. The status will update automatically.
              </Typography>
            </Box>
            <TableContainer component={Paper} sx={{ margin: '20px 30px', width: '94%' }}>
              <Table aria-label="customized table">
                <TableHead sx={{
                  backgroundColor: globalStyles.colors.backgroundPrimary,
                  height: '40px !important',
                  borderRadius: '0 !important',
                  '& .MuiTableCell-root': {
                    color: '#fff !important',
                    padding: '10px !important'
                  }
                }}>
                  <TableRow>
                    {selectedHeaders.map((header) => {
                      return (
                        <StyledTableCell align='center'>{header.label}</StyledTableCell>
                      )
                    })}
                    {registerType !== 'Guest' && (
                      <StyledTableCell align='center'>Action</StyledTableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {listData.map((user) => {
                    return (
                      <StyledTableRow key={user.id} id={user.id}>
                        {selectedHeaders.map((header) => {
                          // if (header.id == 'website_id' && user['website_id'] == 1) {
                          //   return (
                          //     <StyledTableCell align='center'>Shababuna</StyledTableCell>
                          //   )
                          // } else 
                          if (header.id == 'group_id') {
                            return (
                              <StyledTableCell align='center'>{globalConfig.customerGroups[user[header.id]]}</StyledTableCell>
                            )
                          } else if (header.id == 'created_at') {
                            return (
                              <StyledTableCell align='center'>{getModifiedDate(user['created_at'])}</StyledTableCell>
                            )
                          } else if (header.id == 'updated_at') {
                            return (
                              <StyledTableCell align='center'>{getModifiedDate(user['updated_at'])}</StyledTableCell>
                            )

                          } else if (header.id === 'active') {
                            if (registerType === 'Guest') {
                              return (
                                <StyledTableCell align='center'>Guest</StyledTableCell>
                              );
                            } else {
                              if (user[header.id] === 1) {
                                return (
                                  <StyledTableCell align='center'>Active</StyledTableCell>
                                );
                              } else {
                                return (
                                  <StyledTableCell align='center'>Not Active</StyledTableCell>
                                );
                              }
                            }

                            // } else if (header.id == 'firstname') {
                            //   if (user[header['firstname']] != "undefined" && user[header['lastname']] != "undefined") {
                            //     return (
                            //       <StyledTableCell align='center'>{user['firstname'] + ' ' + user['lastname']}</StyledTableCell>
                            //     )
                            //   } else {
                            //     return (
                            //       <StyledTableCell align='center'>NULL</StyledTableCell>
                            //     )
                            //   }
                          } else if (header.id === 'firstname') {
                            // Prefer Arabic if available
                            const firstName = user.firstnamear?.trim() || user.firstname?.trim() || '';
                            const lastName = user.lastnamear?.trim() || user.lastname?.trim() || '';

                            const displayName = [firstName, lastName].filter(n => n).join(' ');

                            return (
                              <StyledTableCell align="center">
                                {displayName || 'NULL'}
                              </StyledTableCell>
                            )
                          } else if (header.id === "vinculum_cust_id") {
                            const value = user[header.id];
                            return (
                              <StyledTableCell align="center">
                                {value ? "True" : "False"}
                              </StyledTableCell>
                            );
                          } else if (header.id === "vinculum_sync_action") {
                            const status = user.sync_status?.toLowerCase();
                            const isSynced = user.vinculum_cust_id !== null && user.vinculum_cust_id !== undefined && user.vinculum_cust_id !== "";
                            return (
                              <StyledTableCell align="center">
                                {user.group_id === 2 ? (
                                  isSynced ? (
                                    <span style={{ color: "green", fontWeight: 500 }}>
                                      Synced
                                    </span>

                                  ) : status === "processing" ? (
                                    <span style={{ color: "#f39c12", fontWeight: 500 }}>
                                      Processing...
                                    </span>

                                  ) : status === "failed" ? (
                                    <span style={{ color: "red", fontWeight: 500 }}>
                                      Failed
                                    </span>

                                  ) : status === "pending" || !status ? (   // ✅ only allow icon in these cases
                                    <Tooltip title="Re-Sync">
                                      <IconButton
                                        size="small"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleVinculumSync(user);
                                        }}
                                        sx={{ color: "#2b3f7a" }}
                                      >
                                        <SyncIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  ) : (
                                    "-"   
                                  )

                                ) : (
                                  "-"
                                )}
                              </StyledTableCell>
                            );
                          }
                          else {
                            return (
                              <StyledTableCell align='center'>
                                {user[header.id]}
                              </StyledTableCell>
                            )
                          }
                        })}
                        {registerType !== 'Guest' && (
                          <StyledTableCell align='center'>
                            <EditIcon
                              onClick={() => handleEditClick(user.id)}
                              sx={{ cursor: 'pointer', color: '#2b3f7a' }}
                            />
                          </StyledTableCell>
                        )}
                      </StyledTableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>


            <Box sx={{ justifyContent: 'center' }}>
              <Pagination count={Math.ceil(totalCount / 50)} page={currentPage} onChange={handlePagination} />
            </Box>
          </List>

        </ResourceContextProvider>
      </React.Fragment>
    )
  }
};

export default UsersList